import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";

export default {
    mixins: [mainRegistrationMixin],
    computed: {

        acadTitles() {
            return this.formSelectChoices.acadTitles
        },

        titles() {
            return this.formSelectChoices.titles
        },

        salutations() {
            return this.formSelectChoices.salutations
        },

        genders() {
            return this.formSelectChoices.genders
        },

        personTypes() {
            return this.formSelectChoices.personTypes
        },

        addressTypes() {
            return this.formSelectChoices.addressTypes
        },

        countries() {
            return this.formSelectChoices.countries
        },

    },
}
